export default "__VITE_ASSET__4fb3131e__"